module.exports = __webpack_public_path__ + "media/packs/images/flags/DE-7707ba8d3ce4d1f7385842cad3eb04f9.png";